'use client';

import React, { FC } from 'react';
import { TypeNavColumnFields } from '@/core/generated-types';
import { DynamicComponent } from '@/components/common/DynamicComponent';

interface NavColumnProps extends TypeNavColumnFields {
  onClose?: () => void;
}

export const NavColumn: FC<NavColumnProps> = ({
  entryName: _entryName,
  items,
  onClose,
}) => {
  return (
    <div data-testid="nav-column" className="flex flex-col gap-7">
      {items?.map((item) => {
        return (
          <DynamicComponent
            component={item}
            key={item.sys.id}
            onClose={onClose}
          />
        );
      })}
    </div>
  );
};

export default React.memo(NavColumn);
